function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const WindIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "wind, gust, air",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 6.5H8.03704C9.39729 6.5 10.5 5.38073 10.5 4.00001C10.5 2.61929 9.39729 1.5 8.03704 1.5C7.24273 1.5 6.44842 1.96566 5.98457 2.66677",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 12.5H12.037C13.3973 12.5 14.5 13.6193 14.5 15C14.5 16.3807 13.3973 17.5 12.037 17.5C11.2427 17.5 10.4484 17.0343 9.98457 16.3332",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 9.5H15.5C17.1569 9.5 18.5 8.15688 18.5 6.50003C18.5 4.84317 17.1569 3.50003 15.5 3.50003C14.5325 3.50003 13.565 4.05881 13 4.90015",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default WindIcon;